import React from 'react';
import { Link } from 'react-router-dom';
import { Card, Container, Row, Col } from 'react-bootstrap';
import './bannerliquidate.css';

const BannerLiquidate = props => {
  const { id } = props;

  return (
    <Card className="informacion-liquidacion">
      <Container>
        <Row>
          <Col md={{ span: 5, offset: 1 }} sm={6} xs={12}>
            <p className="informacion-texto">
              <b>Liquida</b> aquí tu Depósito a Plazo.
            </p>
          </Col>
          <Col md={4} sm={6} xs={12}>
            <Link
              to={{ pathname: '/liquidar/origen', id }}
              className="dap_btn-primary"
            >
              Liquidar
            </Link>
          </Col>
        </Row>
      </Container>
    </Card>
  );
};

export default BannerLiquidate;
